import axios from 'axios';
import { SENTRY_TEST_MESSAGE_PARAM } from '@shared/helpers/sentry-test.helpers';

export const adminSentryTestApi = {
  /**
   * Calls the admin Sentry test API, which throws the same error message as the page.
   * The promise always rejects when the endpoint works.
   */
  throwError: (message: string) =>
    axios.get('/admin/sentry-test', {
      params: { [SENTRY_TEST_MESSAGE_PARAM]: message },
    }),
};
